import { RadialBarChart, RadialBar, ResponsiveContainer } from 'recharts';
import { cn } from '@/lib/utils';

const getColor = (score) => {
  if (score >= 80) return 'hsl(142, 56%, 36%)';
  if (score >= 60) return 'hsl(36, 90%, 50%)';
  return 'hsl(0, 72%, 52%)';
};

export const ComplianceScoreRing = ({ score = 0, size = 140, label = 'Compliance', className }) => {
  const data = [{ value: score, fill: getColor(score) }];
  return (
    <div data-testid="compliance-score-ring" className={cn('flex flex-col items-center', className)}>
      <div style={{ width: size, height: size }} className="relative">
        <ResponsiveContainer width="100%" height="100%">
          <RadialBarChart
            cx="50%" cy="50%"
            innerRadius="72%" outerRadius="100%"
            startAngle={90} endAngle={-270}
            data={data}
            barSize={10}
          >
            <RadialBar
              dataKey="value"
              cornerRadius={5}
              background={{ fill: 'hsl(var(--muted))' }}
              maxAngle={360}
              domain={[0, 100]}
            />
          </RadialBarChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-3xl font-semibold tabular-nums" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            {score}
          </span>
          <span className="text-xs text-muted-foreground">/ 100</span>
        </div>
      </div>
      {label && <span className="mt-2 text-xs uppercase tracking-wider text-muted-foreground">{label}</span>}
    </div>
  );
};
